import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Eye, Clock, ArrowLeft, User } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const StoryCard = ({ story, onClick, index }) => (
  <motion.div
    className="story-card"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3, delay: index * 0.05 }}
    onClick={() => onClick(story)}
  >
    {story.thumbnail && (
      <div className="story-thumb">
        <img loading="lazy" src={story.thumbnail} alt={story.title} />
      </div>
    )}
    <div className="story-card-body">
      <h3 className="story-card-title">{story.title}</h3>
      <p className="story-card-preview">{(story.content || '').replace(/<[^>]*>/g, '').substring(0, 120)}...</p>
      <div className="story-card-meta">
        <span><User size={11} /> {story.author || 'Admin'}</span>
        <span><Eye size={11} /> {story.views || 0}</span>
        <span>{story.category || 'Cerita'}</span>
      </div>
    </div>
  </motion.div>
);

const StoryPage = ({ story, onBack }) => {
  const extractContent = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const styles = div.querySelectorAll("style, script, head");
    styles.forEach(el => el.remove());
    const body = div.querySelector("body");
    return body ? body.innerHTML : div.innerHTML;
  };
  const [fullStory, setFullStory] = useState(story);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/stories/${story.id}`).then(r => setFullStory(r.data)).catch(() => {});
  }, [story.id]);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
      <button className="vp-back" onClick={onBack} style={{ marginBottom: 16 }}>
        <ArrowLeft size={15} /> Back to stories
      </button>
      <div className="story-page">
        {fullStory.thumbnail && (
          <div className="story-page-thumb">
            <img loading="lazy" src={fullStory.thumbnail} alt={fullStory.title} />
          </div>
        )}
        <h1 className="story-page-title">{fullStory.title}</h1>
        <div className="story-page-meta">
          <span><User size={13} /> {fullStory.author || 'Admin'}</span>
          <span><Eye size={13} /> {fullStory.views || 0} views</span>
          <span><Clock size={13} /> {new Date(fullStory.created_at).toLocaleDateString()}</span>
          {fullStory.category && <span className="vp-tag">{fullStory.category}</span>}
        </div>
        <div className="story-page-content">
          <div dangerouslySetInnerHTML={{ __html: extractContent(fullStory.content || "") }} />
        </div>
      </div>
    </motion.div>
  );
};

const StoryList = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStory, setSelectedStory] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios.get(`${BACKEND_URL}/api/stories`).then(r => {
      setStories(r.data.stories || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (selectedStory) {
    return <StoryPage story={selectedStory} onBack={() => setSelectedStory(null)} />;
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 40, color: '#555' }}>
        <BookOpen size={32} style={{ marginBottom: 8 }} />
        <p>Loading stories...</p>
      </div>
    );
  }

  if (stories.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: 60, color: '#555' }}>
        <BookOpen size={48} style={{ marginBottom: 12, opacity: 0.3 }} />
        <h3 style={{ fontSize: 18, color: '#888', marginBottom: 6 }}>Belum ada cerita</h3>
        <p style={{ fontSize: 13 }}>Cerita dewasa akan ditampilkan di sini</p>
      </div>
    );
  }

  return (
    <div>
      <div className="grid-header"><h2 className="grid-title">Cerita Dewasa</h2></div>
      <div className="video-grid">
        {stories.map((s, i) => (
          <StoryCard key={s.id} story={s} onClick={setSelectedStory} index={i} />
        ))}
      </div>
    </div>
  );
};

export default StoryList;
